<script lang="ts">
  import {getContext, onMount} from 'svelte';
  import {navAfterRegisterSuccess} from '@/helper/login';
  import {loadAppleWidget} from '@/resource/js';
  import {userApi} from '@/api';
  import {lang$} from '@/store';
  import {doCaptcha} from '@/captcha';
  import {sendRequest} from '@/modules/bonus/utils';
  import {mc} from '@/core';
  import Spin from '@/widgets/Spin.svelte';
  // import {openAuth} from '@/modules/components/access-apple/utils';
  import '../access-google/access-styled.scss';

  let className = '';
  export {className as class};
  export let scene;
  export let referralCode = '';
  export let group: string | number = '';
  export let target = '';
  export let width = '48';
  export let iconInfo = {
    defaultIcon: 'https://img.phemex.com/v1/fc794379-770f-428b-b214-05c723952f3a/login-apple.png',
    hoverIcon: 'https://img.phemex.com/v1/f4817eac-d687-4512-b74f-e9d8acb4fed2/login-apple-hover.png',
    alt: 'icon',
    visibleTitle: false,
  };

  const LG = getContext('LG');
  const tips = {
    en: 'Apple login on web is being upgraded, use Phemex App for Apple login.',
  };
  let ready = false;
  let loading = false;

  onMount(async () => {
    loadAppleWidget().then(() => {
      ready = true;
    });
  });

  async function handleClick() {
    mc.send('toast', 'error', {message: LG(tips)});
    // if (!ready || loading) {
    //   return;
    // }
    // loading = true;
    // // const redirectUrl = 'https://dev.cmexpro.com/login';
    // const redirectUrl = window.location.origin;
    // const nonce = Math.random().toString(36).substr(2, 10);
    // const {data, error} = await openAuth(redirectUrl, nonce);
    // if(error) {
    //   loading = false;
    //   console.error(error);
    // }
    // if(data){
    //   login(data, nonce);
    // }
  }

  async function login(aData, nonce) {
    const params = {
      group,
      authSource: 'apple',
      lang: $lang$,
      referralCode,
      nickName: '',
      authToken: aData.id_token,
      nonce,
      userDeviceLang: (navigator.language || navigator.userLanguage).substring(0, 2),
    };
    const captchaResult = await doCaptcha('register');
    const {data, error} = await sendRequest(userApi.authLogin(captchaResult, params));
    if (data?.decision === 1 || data?.decision === 3) {
      const params = {email: data.email, code: data.code};
      const {data: data2} = await sendRequest(userApi.confirmAuthLogin(params));
      if (data2) {
        navAfterRegisterSuccess(target);
      }
    }
    loading = false;
  }
</script>

<style>
  .loading {
    cursor: not-allowed;
    opacity: 0.5;
  }
</style>

<section class="wallet-connect-box">
  <div class="pr f16 df cp {className}" style="padding: 0" on:click|stopPropagation={handleClick}>
    <div class="df fdc jcc aic" class:loading={!ready || loading}>
      <div class="img df jcc aic pr">
        <img {width} height={width} data-replace-icon="false" src={iconInfo.defaultIcon} alt={iconInfo.alt} />
        <img {width} height={width} class="white" data-replace-icon="false" src={iconInfo.hoverIcon} alt={iconInfo.alt} />
      </div>
      {#if iconInfo.visibleTitle}
        <div class="con mt12 f12 lh18 T3 sm:hidden">Apple</div>
      {/if}
    </div>
  </div>
</section>
